import React, { useEffect } from "react";
import { ArrowRight } from "lucide-react";
import PageLayout from "@/components/layout/pageLayout/PageLayout";
import HomeHeader from "./HomeHeader";
import Footer from "@/components/layout/footer/Footer";
import DashboardMockup from "./components/DashboardMockup";
import StatsBand from "./components/StatsBand";
import FeatureCards from "./components/FeatureCards";
import styles from "./Home.module.css";
import { useNavigate } from "react-router-dom";

const Home: React.FC = () => {
    const navigate = useNavigate();
    const handleLoginRedirect = () => navigate("/login");

    useEffect(() => {
        document.body.classList.add("solid-public-bg");
        return () => document.body.classList.remove("solid-public-bg");
    }, []);

    return (
        <PageLayout
            header={<HomeHeader />}
            main={
                <div className={styles["landing"]}>
                    <section className={styles["hero"]}>
                        <div className={styles["hero-text"]}>
                            <h1 className={styles["home-main-title"]}>
                                Cursos de liderazgo acádemico{" "}
                                <span className={styles["home-accent"]}>PREICFES</span>
                            </h1>
                            <p className={styles["home-subtitle"]}>
                                Visualiza, compara y optimiza tu rendimiento académico con
                                EDUDATA. Presenta simulacros tipo ICFES y conoce tus
                                resultados al instante.
                            </p>
                            <div className={styles["home-cta-container"]}>
                                <button
                                    onClick={handleLoginRedirect}
                                    className={`${styles["home-cta-button"]} ${styles["home-primary-cta"]}`}
                                    aria-label="Iniciar sesión en EDUDATA"
                                >
                                    INICIA SESIÓN
                                    <ArrowRight size={18} className={styles["cta-arrow"]} />
                                </button>
                            </div>
                        </div>

                        <div className={styles["hero-visual"]}>
                            <DashboardMockup />
                        </div>
                    </section>

                    <StatsBand />

                    <FeatureCards />
                </div>
            }
            footer={<Footer />}
        />
    );
};

export default Home;
